export default __webpack_public_path__ + "static/media/pdf.e7883b94.pdf";